import React from 'react';
import ChatAssistant from './ChatAssistant.jsx';

// ChatShell wraps the ChatAssistant and renders agent children
const ChatShell = ({ children }) => {
  return (
    <ChatAssistant>
      {children}
    </ChatAssistant>
  );
};

export default ChatShell; 